export enum OrderType {
  DineIn = 0,
  TakeAway = 1,
  Delivery = 2,
}
